import { styled } from "@mui/material/styles";
import { Tooltip, tooltipClasses, TooltipProps } from "@mui/material";
import moment from "jalali-moment";
import { FollowUpType } from "src/interface/enum/FollowUpType";
import { StatusGlobal } from "src/interface/enum/StatusGlobal";
import { UseMutateAsyncFunction } from "@tanstack/react-query";
import { SyncOptions } from "src/interface/ISyncOptions";
import { ITransaction } from "src/interface/ITransaction";
import { FormikProps } from "formik";
var jalaali = require("jalaali-js");
// export const API_URL = "http://localhost:5259/api/";
export const API_URL = "https://api.teknohesab.ir/api/";

export const BootstrapTooltip = styled(
  ({ className, ...props }: TooltipProps) => (
    <Tooltip {...props} arrow classes={{ popper: className }} />
  )
)(({ theme }) => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: theme.palette.common.black,
  },
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.common.black,
  },
}));

export const handleSendMessage = (
  notifications: any,
  message: string,
  type: "info" | "warning" | "error" | "success",
  duration = 5000,
  key = "alert"
) => {
  notifications.show(message, {
    key: key,
    severity: type,
    autoHideDuration: duration,
  });
};

export function remainingSeasonsInPersianYear(inputDate: Date): number {
  const today = moment(inputDate); // تاریخ ورودی
  const currentMonth = today.jMonth(); // شماره ماه شمسی (0 تا 11)
  const seasons = [
    { startMonth: 0, endMonth: 2 }, // بهار (فروردین تا خرداد)
    { startMonth: 3, endMonth: 5 }, // تابستان (تیر تا شهریور)
    { startMonth: 6, endMonth: 8 }, // پاییز (مهر تا آذر)
    { startMonth: 9, endMonth: 11 }, // زمستان (دی تا اسفند)
  ];

  // بررسی اینکه در کدام فصل هستیم
  for (let i = 0; i < seasons.length; i++) {
    const season = seasons[i];
    if (currentMonth <= season.endMonth) {
      return 4 - i; // تعداد فصل‌های باقی‌مانده
    }
  }

  return 1; // در صورتی که به پایان سال رسیده باشیم
}

export const calculateSession = (
  countSession: number,
  type?: FollowUpType
): number => {
  if (type === FollowUpType.Fasli) {
    return countSession;
  }
  if (type === FollowUpType.Yearly) {
    return 1;
  }
  if (type === FollowUpType.Monthly) {
    return countSession * 3;
  }
  return 1;
};

export const calculateDates = (
  startDate: string,
  endDate: string,
  frequency: FollowUpType,
  period: number
) => {
  // تبدیل تاریخ میلادی به شمسی
  const startMoment = moment(startDate, "YYYY-MM-DD").locale("fa");
  const endMoment = moment(endDate, "YYYY-MM-DD").locale("fa");
  const result = [];

  if (
    startMoment.isValid() &&
    endMoment.isValid() &&
    startMoment.isBefore(endMoment)
  ) {
    let current = startMoment.clone();

    while (current.isBefore(endMoment) || current.isSame(endMoment)) {
      // بررسی اینکه آیا روز تاریخ پایان کمتر از روز تاریخ شروع است
      if (
        current.isSame(endMoment, "month") &&
        endMoment.date() < current.date()
      ) {
        break; // نادیده گرفتن ماه آخر
      }
      const [year, month, day] = current
        .format("YYYY-MM-DD")
        .split("-")
        .map(Number);
      const miladi = moment
        .from(`${year}/${month}/${day}`, "fa", "YYYY/MM/DD")
        .format("YYYY/MM/DD");

      // تبدیل تاریخ شمسی به میلادی و اضافه کردن به آرایه خروجی
      result.push(miladi);
      switch (frequency) {
        case FollowUpType.Weekly:
          current.add(period, "weeks");
          break;

        case FollowUpType.Monthly:
          current.add(period, "months");
          break;

        case FollowUpType.Fasli:
          current.add(period * 3, "months");
          break;
        case FollowUpType.Yearly:
          current.add(period * 12, "months");
          break;
        default:
          break;
      }
    }
  }

  return result;
};

export const chekEmptyField = (value?: any, output?: any) => {
  if (
    value !== null &&
    value !== undefined &&
    value !== "NULL" &&
    value !== ""
  ) {
    return value;
  } else {
    return output ?? undefined;
  }
};

export const handleChange = (
  event: React.MouseEvent<HTMLElement>,
  newValue: any,
  fieldName: string,
  formik: FormikProps<any>
) => {
  formik.setFieldValue(fieldName, newValue);
};

export function convertJalaaliToGregorian(
  jalaaliDate: string
): Date | undefined {
  // تاریخ شمسی را به قسمت‌های سال، ماه و روز تقسیم می‌کنیم
  const [year, month, day] = jalaaliDate.split("/").map(Number);

  // بررسی صحت تاریخ شمسی
  if (!jalaali.isValidJalaaliDate(year, month, day)) {
    console.error("تاریخ شمسی وارد شده معتبر نیست.");
    return undefined;
  }

  // تبدیل تاریخ شمسی به میلادی
  const gregorianDate = jalaali.toGregorian(year, month, day);

  // ایجاد یک شیء Date از تاریخ میلادی
  return new Date(gregorianDate.gy, gregorianDate.gm - 1, gregorianDate.gd);
}

export const localOptions: Intl.DateTimeFormatOptions = {
  timeZone: "Asia/Tehran",
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
  hour: "2-digit",
  minute: "2-digit",
  second: "2-digit",
  hour12: false,
};

export const ConvertToMiladiDateDB = (date: string) => {
  const startedOnDate = new Date(date);
  return (
    startedOnDate.toLocaleString("sv-SE", localOptions).replace(" ", "T") +
    "+03:30"
  );
};

export const ConvertToShamsiDate = (date?: string): string => {
  return date
    ? moment.from(date, "en", "YYYY-MM-DD").format("jYYYY/jMM/jDD")
    : "-";
};

export const handleCopy = (e: any, notifications: any) => {
  if (navigator.clipboard) {
    navigator.clipboard
      .writeText(e)
      .then(() => {
        handleSendMessage(notifications, "کپی شد", "success");
        console.log("متن با موفقیت کپی شد!");
      })
      .catch((err) => {
        console.error("خطا در کپی متن: ", err);
      });
  } else {
    // fallback با استفاده از textarea
    const textarea = document.createElement("textarea");
    textarea.value = e;
    document.body.appendChild(textarea);
    textarea.select();
    try {
      document.execCommand("copy");
      handleSendMessage(notifications, "کپی شد", "success");
    } catch (err) {
      console.error("خطا در کپی متن: ", err);
    }
    document.body.removeChild(textarea);
  }
};

const getId = (item: any) => item.id;

export async function syncItems<T>({
  isEdit,
  existingItems,
  updatedItems,
  deleteItemAsync,
  updateItemAsync,
  insertItemAsync,

  RefField,
  RefValue,
}: SyncOptions<T>): Promise<void> {
  // حذف آیتم‌هایی که در updatedItems نیستند (در حالت ویرایش)
  if (isEdit && existingItems && existingItems.length > 0) {
    console.log("🚀 ~ syncItems ~ existingItems:", existingItems);

    await Promise.all(
      existingItems.map(async (existingItem) => {
        if (
          !updatedItems?.find(
            (updated) => getId(updated) === getId(existingItem)
          )
        ) {
          const res = await deleteItemAsync({ id: getId(existingItem) });
          console.log("🚀 ~ syncItems ~ res:delete", res);
        }
      })
    );
  }

  // ویرایش یا افزودن آیتم‌ها (در حالت ویرایش)
  console.log("🚀 ~ syncItems ~ updatedItems:", updatedItems);
  if (isEdit && updatedItems && updatedItems.length > 0) {
    await Promise.all(
      updatedItems.map(async (item) => {
        if (
          existingItems?.find((existing) => getId(existing) === getId(item))
        ) {
          const res = await updateItemAsync({ ...item, [RefField]: RefValue }); // ویرایش
          console.log("🚀 ~ syncItems ~ res:", res);
        } else {
          const res = await insertItemAsync({ ...item, [RefField]: RefValue }); // افزودن
          console.log("🚀 ~ syncItemsinsert~ res:", res);
        }
      })
    );
  }
  // افزودن آیتم‌های جدید (در حالت غیر ویرایش)
  else if (!isEdit && updatedItems && updatedItems.length > 0) {
    await Promise.all(
      updatedItems.map(async (item) => {
        const res = await insertItemAsync({ ...item, [RefField]: RefValue });
        console.log("🚀 ~ syncItems ~ res:insertNotEdit", res);
      })
    );
  }
}

export const calculateBalance = (
  transactions?: ITransaction[],
  customerRef?: string // اختیاری برای فیلتر کردن بر اساس مشتری
): number => {
  // فیلتر کردن تراکنش‌ها بر اساس customerRef اگه مشخص شده باشه
  const filteredTransactions = customerRef
    ? transactions?.filter((t) => t.customerRef === customerRef)
    : transactions;

  if (filteredTransactions && filteredTransactions.length > 0) {
    // مرتب‌سازی تراکنش‌ها بر اساس تاریخ تراکنش
    const sortedTransactions = [...filteredTransactions].sort((a, b) => {
      const dateA = a.transactionDate
        ? new Date(a.transactionDate)
        : new Date(0);
      const dateB = b.transactionDate
        ? new Date(b.transactionDate)
        : new Date(0);
      return dateA.getTime() - dateB.getTime();
    });

    // محاسبه جمع بدهکاری‌ها و بستانکاری‌ها
    const totalDebit = sortedTransactions?.reduce((sum, t) => {
      if (t.isDebit === true && t.amount !== undefined) {
        return sum + t.amount;
      }
      return sum;
    }, 0);

    const totalCredit = sortedTransactions?.reduce((sum, t) => {
      if (t.isDebit === false && t.amount !== undefined) {
        return sum + t.amount;
      }
      return sum;
    }, 0);

    // مانده = بدهکاری - بستانکاری
    const balance = (totalDebit ?? 0) - (totalCredit ?? 0);

    return balance;
  }
  return 0;
};

// ==================== توابع کمکی برای پیگیری‌ها ====================

/**
 * پردازش داده‌های پیگیری با اضافه کردن اطلاعات سرویس و مشتری
 * @param followupData - آرایه داده‌های پیگیری
 * @param services - آرایه سرویس‌ها
 * @returns آرایه پردازش شده با اطلاعات اضافی
 */
export const processFollowupData = (followupData: any[], services: any[]) => {
  return followupData.map((f) => ({
    ...f,
    serviceName: services.find((s) => s.id === f.serviceRef)?.name || "",
    customerName: `${
      f.customer?.fName || ""
    } ${f.customer?.lName || ""}\n${f.customer?.coName || ""}`.trim(),
  }));
};

/**
 * پیدا کردن تمام serviceRef هایی که در گروه‌های سرویس قرار دارند
 * @param serviceGroups - آرایه گروه‌های سرویس
 * @param services - آرایه سرویس‌ها
 * @returns Set از serviceRef های گروه‌بندی شده
 */
export const getGroupedServiceRefs = (
  serviceGroups: any[],
  services: any[]
) => {
  const groupedServiceRefs = new Set();
  serviceGroups?.forEach((group) => {
    const groupServices = services.filter((s) => s.serviceGroupId === group.id);
    groupServices.forEach((service) => groupedServiceRefs.add(service.id));
  });
  return groupedServiceRefs;
};

/**
 * ایجاد تابع fetch عمومی برای درخواست‌های API
 * @param user - اطلاعات کاربر
 * @param Routes - مسیرهای API
 * @returns تابع fetch با تنظیمات پیش‌فرض
 */
export const createFetchFunction = (user: any, Routes: any) => (url: string) =>
  fetch(url, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${user?.token}`,
      Accept: "application/json",
    },
  }).then((res) => res.json());

// ==================== توابع کمکی برای تب پنل ====================

/**
 * بررسی اینکه آیا تاریخ در محدوده دو هفته آینده است
 * @param date - تاریخ مورد بررسی
 * @returns true اگر در محدوده دو هفته آینده باشد
 */
export const isWithinTwoWeeks = (date: string) => {
  const dueDate = moment(date).startOf("day");
  const twoWeeksLater = moment().add(2, "weeks").endOf("day");
  return dueDate.isSameOrBefore(twoWeeksLater);
};

/**
 * مرتب‌سازی بر اساس تاریخ و اولویت
 * @param a - آیتم اول
 * @param b - آیتم دوم
 * @param dateField - نام فیلد تاریخ
 * @param priorityField - نام فیلد اولویت
 * @returns عدد منفی، صفر یا مثبت برای مرتب‌سازی
 */
export const sortByDateAndPriority = (
  a: any,
  b: any,
  dateField: string,
  priorityField: string
) => {
  const dateA = moment(a[dateField]);
  const dateB = moment(b[dateField]);
  if (dateA?.isSame(dateB)) {
    return (a[priorityField] ?? 0) - (b[priorityField] ?? 0);
  }
  return dateA.isBefore(dateB) ? -1 : 1;
};

/**
 * فیلتر کردن کارهای فعال (غیر تکمیل و غیر لغو شده)
 * @param tasks - آرایه کارها
 * @returns آرایه کارهای فعال
 */
export const filterActiveTasks = (tasks: any[]) => {
  return tasks.filter(
    (t) =>
      t.statusTask !== StatusGlobal.Completed &&
      t.statusTask !== StatusGlobal.Canceled
  );
};

/**
 * فیلتر کردن پیگیری‌های فعال (غیر تکمیل و غیر لغو شده)
 * @param followups - آرایه پیگیری‌ها
 * @returns آرایه پیگیری‌های فعال
 */
export const filterActiveFollowups = (followups: any[]) => {
  return followups.filter(
    (f) =>
      (f.lastTaskLog &&
        f.lastTaskLog.statusTask !== StatusGlobal.Completed &&
        f.lastTaskLog.statusTask !== StatusGlobal.Canceled) ||
      f.lastTaskLog === null
  );
};
